import { createSSRApp, getCurrentInstance } from 'vue'
import Vuex from 'vuex'
import App from './App'

import request from "./utils/request.js"
// Vue.config.productionTip = false
import { toast, message, success } from "./utils/plugin"
import ApiGloabal from "./utils/api.js"
import jwx from "./utils/jwx.js"

import store from './store'
// #ifdef H5-UAT
// import vconsole from "vconsole"
// new vconsole()
// #endif

// Vue.use(toast).use(message).use(success)
export function createApp() {
  const app = createSSRApp(App)
  // const app = createApp();
  app.config.globalProperties.$api = ApiGloabal;
  app.config.globalProperties.request = request;
  app.config.globalProperties.$store = store;
  app.config.globalProperties.$jwx = jwx
  app.use(store).use(toast).use(message).use(success)
  return {
      app,
	  Vuex,
  }
}
// Vue 3 转 Vue 2, 在 main.js 中写入以下代码即可
function isPromise(obj) {
  return (
    !!obj &&
    (typeof obj === "object" || typeof obj === "function") &&
    typeof obj.then === "function"
  );
}

uni.addInterceptor({
  returnValue(res) {
    if (!isPromise(res)) {
      return res;
    }
    const returnValue = [undefined, undefined];
    return res
      .then((res) => {
        returnValue[1] = res;
      })
      .catch((err) => {
        returnValue[0] = err;
      })
      .then(() => returnValue);
  },
});



